import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "iframe-header"
};
var _hoisted_2 = {
  class: "iframe-header-title"
};
var _hoisted_3 = {
  class: "iframe-header-btns"
};
var _hoisted_4 = {
  class: "iframe-box"
};
var _hoisted_5 = ["src"];
import { onMounted, ref, toRefs } from 'vue';
import { uploadObs } from 'hxhy-obs';
import { MessagePlugin } from 'tdesign-vue-next';
import { getStore } from '@/util/store';
import { saveOrUpdateTool } from '@/api/excersise';
import { getEnvName } from '@/util/env';
export default {
  __name: 'edit',
  props: {
    formulaEditVisible: {
      // 分享浮层、弹窗显隐
      type: Boolean,
      default: false
    },
    latex: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '未命名的数学公式'
    }
  },
  emits: ['update:formulaEditVisible', 'getFormulaInfo'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var visible = ref(props.formulaEditVisible);
    var closeDialog = function closeDialog() {
      emit('update:formulaEditVisible', false);
    };
    var userInfo = getStore({
      name: 'userInfo'
    });
    var editTitle = ref(false);
    var formulaName = ref(props.name);
    var handleEdit = function handleEdit() {
      editTitle.value = true;
    };
    var handleBlur = function handleBlur() {
      if (!formulaName.value) formulaName.value = '未命名的数学公式';
      editTitle.value = false;
    };
    var FRAME_URL = ref('');
    var BASE_URL = window.location.origin + 'sub-learning-tools-svc/';
    FRAME_URL.value = props.latex ? "".concat(BASE_URL, "cdn/formula/hxhyFormula.html?latex=").concat(props.latex) : "".concat(BASE_URL, "cdn/formula/hxhyFormula.html");
    var getFormulaData = function getFormulaData() {
      return new Promise(function (resolve, reject) {
        var ifr = document.getElementById('iframeFormula');
        ifr.contentWindow.postMessage('save', '*');
        var waiting = setTimeout(function () {
          reject(new Error('处理超时'));
        }, 5000);
        window.onmessage = function (e) {
          var data = e.data;
          if (data.action === 'recive') {
            clearTimeout(waiting);
            resolve(data.content);
          }
        };
      });
    };
    // 上传获取url
    var getUrl = function getUrl(file) {
      return new Promise(function (resolve) {
        var bucketSuffix = ['dev', 'test', 'pre', 'prod'].find(function (v) {
          return window.location.host.includes(v);
        }) || 'prod';
        var obsData = {
          bucketName: "hxhy-base-".concat(bucketSuffix),
          file: file,
          fileType: 2,
          userId: userInfo.id,
          userName: userInfo.name,
          institutionId: userInfo.institutionId,
          institutionName: userInfo.institutionName,
          appCode: 'learningTools',
          appName: '工具箱',
          pageName: 'formulaDetail',
          btnName: '保存'
        };
        uploadObs(obsData).then(function (url) {
          resolve(url);
        });
      });
    };
    var getData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, file, url;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getFormulaData();
            case 1:
              res = _context.v;
              file = new File([res.url], "".concat(new Date().getTime(), ".svg"), {
                type: res.url.type.split(';')[0]
              });
              _context.n = 2;
              return getUrl(file);
            case 2:
              url = _context.v;
              if (!url.includes('http')) url = "https:".concat(url);
              return _context.a(2, {
                url: url,
                latex: encodeURIComponent(res.latex)
              });
          }
        }, _callee);
      }));
      return function getData() {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleAdd = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$getData, url, latex, element;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getData();
            case 1:
              _yield$getData = _context2.v;
              url = _yield$getData.url;
              latex = _yield$getData.latex;
              console.log('handleAdd', url, latex);
              element = {
                url: url,
                latex: latex,
                name: formulaName.value
              };
              emit('getFormulaInfo', element);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handleAdd() {
        return _ref3.apply(this, arguments);
      };
    }();
    var saveData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$getData2, url, latex, data, res, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.n = 1;
              return getData();
            case 1:
              _yield$getData2 = _context3.v;
              url = _yield$getData2.url;
              latex = _yield$getData2.latex;
              data = {
                id: null,
                toolType: 3,
                // 数学公式
                toolCover: url,
                // 封面
                toolName: formulaName.value,
                // 名称
                toolData: latex // 工具内容
              };
              _context3.p = 2;
              _context3.n = 3;
              return saveOrUpdateTool(data);
            case 3:
              res = _context3.v;
              if (res.data.code === 0) {
                MessagePlugin.success('保存成功！');
              }
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t = _context3.v;
              MessagePlugin.error('保存失败!');
            case 5:
              return _context3.a(2);
          }
        }, _callee3, null, [[2, 4]]);
      }));
      return function saveData() {
        return _ref4.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_icon = _resolveComponent("t-icon");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_space = _resolveComponent("t-space");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return visible.value = $event;
        }),
        width: "1338px",
        class: "formula-edit-dialog tool-dialog",
        placement: "center",
        header: false,
        footer: false,
        attach: "body",
        "confirm-btn": null,
        "cancel-btn": null,
        "close-btn": false,
        "destroy-on-close": "",
        "on-close": closeDialog
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [editTitle.value ? (_openBlock(), _createBlock(_component_t_input, {
            key: 0,
            modelValue: formulaName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return formulaName.value = $event;
            }),
            onBlur: handleBlur
          }, null, 8, ["modelValue"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("span", null, _toDisplayString(formulaName.value), 1), _createVNode(_component_t_icon, {
            name: "pen-ball",
            size: "14px",
            onClick: handleEdit
          })], 64))]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_t_space, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_button, {
                theme: "primary",
                onClick: handleAdd
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode("完成", -1)]));
                }),
                _: 1
              }), _createVNode(_component_t_button, {
                theme: "default",
                onClick: saveData
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("另存为", -1)]));
                }),
                _: 1
              }), _createVNode(_component_t_button, {
                theme: "default",
                onClick: closeDialog
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("取消", -1)]));
                }),
                _: 1
              })];
            }),
            _: 1
          })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("iframe", {
            id: "iframeFormula",
            src: FRAME_URL.value,
            frameborder: "0",
            sandbox: "allow-same-origin allow-scripts"
          }, null, 8, _hoisted_5)])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};